import { Component, OnDestroy, OnInit, SimpleChanges,OnChanges, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, AfterViewInit } from '@angular/core';
import { FormBuilder, Validators, ControlContainer, FormGroupDirective, FormControl, FormGroup } from '@angular/forms';
import { DropzoneComponent, DropzoneDirective, DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerService } from '../../services/customer.service';
import { OrdersService } from '../../services/orders.service';
import { CreditService } from '../../services/credit.service';
import { UsersService } from '../../services/users.service';
import { PaymentsService } from '../../services/payments.service';
import { DispatchService } from '../../services/dispatch.service';
import { Location } from '@angular/common'
import { Subject, Observable } from 'rxjs';
import { DatePipe } from '@angular/common';
import { DataTableDirective } from 'angular-datatables';
import { TableModule } from 'primeng/table';
import * as FileSaver from 'file-saver';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { Product } from '../../classes/orders';
import { normalizeSalesmanAllowed } from '../../classes/default-salesman-allowed';
import { normalizePosAllowed } from '../../classes/default-pos-allowed';
import { Directive, HostListener, ViewEncapsulation } from '@angular/core';
import { trigger, state, style, transition, animate, query, group, stagger } from '@angular/animations';
import { forkJoin , } from 'rxjs';
import { takeUntil, map, switchMap } from 'rxjs/operators';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { OmsService } from 'app/services/oms.service';
import { InventoryService } from 'app/services/inventory.service';
@Component({
	selector: 'app-view',
	templateUrl: './view.component.html',
	styleUrls: ['./view.component.scss'],
	encapsulation: ViewEncapsulation.Emulated,
	animations: [
		trigger('flipState', [
			state('active', style({
				transform: 'rotateY(-179deg)'
			})),
			state('inactive', style({
				transform: 'rotateY(0)'
			})),
			transition('inactive => active', animate('250ms ease-in')),
			transition('active => inactive', animate('250ms ease-out')),
		]),
		trigger('openClose', [
			state(':enter', style({ height: '*' })),
			state(':leave', style({ height: '0px' })),
			transition('false <=> true', animate(500))
		]),
		trigger('filterAnimation', [
			transition(':enter, * => 0, * => -1', []),
			transition(':increment', [
				query(':enter', [
					style({ opacity: 0, width: 0 }),
					stagger(50, [
						animate('300ms ease-out', style({ opacity: 1, width: '*' })),
					]),
				], { optional: true })
			]),
			transition(':decrement', [
				query(':leave', [
					stagger(50, [
						animate('300ms ease-out', style({ opacity: 0, width: 0 })),
					]),
				])
			]),
		]),
		trigger('grow', [ // Note the trigger name
			transition(':enter', [
				// :enter is alias to 'void => *'
				style({ height: '0', width: '0' }),
				animate(200, style({ height: '*', width: '*' })),
				animate('200ms', style({ opacity: 1 })),
			]),
			transition(':leave', [
				// :leave is alias to '* => void'
				animate(100, style({ height: 0, width: 0, })),
				animate('100ms', style({ opacity: 0 }))
			])
		]),
	]
})



export class ViewComponent implements OnInit {
	@ViewChild('pricebookModal') pricebookModalRef: ElementRef;
	@ViewChild('documentModal') documentModalRef: ElementRef;
	@ViewChild('inactiveModal') inactiveModalRef: ElementRef;
	@ViewChild('monthDetails') monthDetailsRef: ElementRef;
	@ViewChild('changelogModal') changelogModalRef: ElementRef;
	private destroy$ = new Subject < void > ();

	selectedbranch: any = [];
	closeResult: any = [];
	text_add_button = 'Add New Ship-To';
	files: File[] = [];
	uploadresults: any = [];
	customernumber: any;
	customerdata: any = [];
	customertrans: any = [];
	flip_button_txt = 'Transactions';
	viewingtrans: any = 'transactions';
	flip = 'inactive';
	//force on for edits
	ctl = false;
	transactions: any = [];
	customer_files: any = [];
	view_index = 0;

	viewingdoc: any = false;
	orderdata: any = [];
	quotes: any;
	payment = false;
	editbilling = false;
	newcustomertoggle = false;
	edittoggle = false;
	editing_settings = false;
	editing_shipping = false;
	editing_notes = false;
	editing_contacts = false;
	
	// Notes filtering
	noteFilterTypes = ['ALL', 'ORDER', 'POS', 'BACK_OFFICE', 'AR', 'INTERNAL', 'DISPATCH', 'SHIP'];
	selectedNoteFilter = 'ALL';
	filteredNotes: any[] = [];
	editing_ar = false;
	attach_file = false;
	invoicing = false;
	customerpoline = false;
	emailstatement = false;
	invoiceemailaddress: any = '';
	ediinvoices = false;
	statementemailaddress: any = '';
	debtorno: any;
	color = 'blue';
	pricelists: any = [];
	reloadData = true;
	activeIndex = 0;
	primaryActiveIndex = 0;

	loadedQuote = false;

	resetTrans: Subject < boolean > = new Subject < boolean > ();
	config: any = [];
	credit_data: any = [];
	user: any = [];
	routes: any = [];
	isItemLookup = false;
	viewingcards = false;
	profile_cards: any = false;
	loadingcards: any = false;
	taxauths: any = false;

	// CRM properties
	leadStatuses: any[] = [];
	opportunityStages: any[] = [];
	activityTypes: any[] = [];

	editsallowed: any = {
		discounts: true,
		editar: true,
		editbilling: true,
		editshipping: true,
		editcontact: true,
		editprofile: true,
		editnotes: true,
		takepayment: true,
		viewrma: true,
	}

	sending: any = false;
	brand_details: any = false;
	isactive: any = true;
	refusedemail: any = false;
	activecolor = 'green';


	private sort: MatSort;
	lookingForRma: any = false;
	@ViewChild(MatSort) set matSort(ms: MatSort) {
		this.sort = ms;
		this.setDataSourceAttributes();
	}

	@ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
		this.paginator = mp;
		this.setDataSourceAttributes();
	}

	setDataSourceAttributes() {
		this.dataSource.paginator = this.paginator;
	}

	dataSource: MatTableDataSource < any > ;
	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	dataObs: Observable < any > ;
	items_per_page = [25, 50, 100, 200, 500];
	pageSize = 25;
	pagesizedefault = 25;
	isPosUser: any = false;
	changelogdebtor: any = false;

	constructor(private omsService: OmsService, private creditService: CreditService, private usersService: UsersService, private paymentsService: PaymentsService, private dispatchService: DispatchService, private route: ActivatedRoute, private customerService: CustomerService, public orderService: OrdersService, private location: Location, public router: Router, public cdr: ChangeDetectorRef, private globalSearchService: GlobalSearchService, private modalService: NgbModal, private inventoryService: InventoryService) {

		this.omsService.setPrintedOrder();

		this.dispatchService.getRoutes()
			.pipe(takeUntil(this.destroy$))
			.subscribe(r => {
				this.routes = r;
			});

		this.globalSearchService.taxgroups
			.pipe(takeUntil(this.destroy$))
			.subscribe(r => {
				this.taxauths = r;
			});

		this.globalSearchService.salestypes
			.pipe(takeUntil(this.destroy$))
			.subscribe(r => {
				this.pricelists = r;
			});

		// Load CRM types
		this.globalSearchService.lead_statuses
			.pipe(takeUntil(this.destroy$))
			.subscribe(r => {
				this.leadStatuses = r;
			});

		this.globalSearchService.opportunity_stages
			.pipe(takeUntil(this.destroy$))
			.subscribe(r => {
				this.opportunityStages = r;
			});

		this.globalSearchService.activity_types
			.pipe(takeUntil(this.destroy$))
			.subscribe(r => {
				this.activityTypes = r;
			});

		this.globalSearchService.configsubscription
			.pipe(takeUntil(this.destroy$))
			.subscribe(r => {
				this.config = r;

				this.globalSearchService.user
					.pipe(takeUntil(this.destroy$)) // nested but still needs cleanup
					.subscribe(u => {
						this.user = u;
						if (u.user.issalesman) {
							this.editsallowed = normalizeSalesmanAllowed(r.salesmanAllowed);
						}
					});
					this.usersService.isPosUser()
						.pipe(takeUntil(this.destroy$))
						.subscribe((isPOS) => {
							if (isPOS) {
								this.isPosUser = true;
								this.editsallowed = normalizePosAllowed(r.posAllowed);
							}
						});
				
			});

		this.usersService.isPosUser()
			.pipe(takeUntil(this.destroy$))
			.subscribe((isPOS) => {
				if (isPOS) {
					this.isPosUser = true;
				}
			});

	}

	updatePageSize(event: any) {
		this.pageSize = event.value;
	}

	getRouteName(id: any) {
		if (id) {
			const route = this.routes.filter(r => {
				return r.route_Id == id;
			})[0]

			if (route) {
				return route.route_description;
			}
			return '';
		} else {
			return '';
		}
	}

	toggleCreditCards() {
		this.viewingcards = (this.viewingcards) ? false : true;
	}

	extractCustomerData(customer: any): any {
		const payload: any = {
			name: customer.name,
			customerId: customer.debtorno,
			branchCode: customer.branchcode,
			address: `${customer.address1}, ${customer.address2}, ${customer.address3}, ${customer.address4}, ${customer.address5}, ${customer.address6}`,
			email: customer.email,
			phone: customer.phoneno,
			salesperson: customer.salesman,
			creditLimit: customer.creditlimit,
			paymentTerms: customer.paymentterms,
			lastPurchaseDate: customer.last_purchase,
			totalSpend: customer.totalspend,
			avgMonthlySales: customer.avg_monthly_sales,
			avgMonthlyQty: customer.avg_monthly_qty,
			returnPercent: customer.return_percent,
			topBrands: customer.topthree?.map(brand => ({
				name: brand.name,
				salesCount: brand.brandcount
			})),
			currentBalance: customer.aged?.balance,
			overdueBalance: customer.aged?.overdue,
			recentPayments: {
				lastPaidAmount: customer.lastpaid,
				lastPaidDate: customer.lastpaiddate
			},
			status: customer.isactive ? 'Active' : 'Inactive',
			estimatedDeliveryDays: customer.estdeliverydays,
			shippingAddress: customer.shipto,
			billingAddress: customer.billto
		};

		if (customer.aged) {
			const aged = customer.aged;
			payload.transactionSummary = {
				totalBalance: aged.balance || 0,
				current: aged.current || 0,
				days30: aged.days30 || 0,
				days60: aged.days60 || 0,
				days90: aged.days90 || 0,
				overdue: aged.overdue || 0,
				transactionCount: aged.transaction_count || 0
			};

			if (aged.overdue && aged.overdue > 0) {
				const daysOverdue = this.calculateDaysOverdue(customer.last_purchase, customer.lastpaiddate);
				payload.creditRisk = {
					overdueAmount: aged.overdue,
					daysOverdue: daysOverdue,
					creditUtilization: customer.creditlimit ? ((aged.balance || 0) / customer.creditlimit) * 100 : null,
					riskLevel: this.calculateCreditRiskLevel(aged.overdue, customer.creditlimit, daysOverdue)
				};
			}
		}

		if (customer.lastpaid && customer.lastpaiddate) {
			const paymentFrequency = this.calculatePaymentFrequency(customer.last_purchase, customer.lastpaiddate);
			payload.paymentPatterns = {
				lastPaymentAmount: customer.lastpaid,
				lastPaymentDate: customer.lastpaiddate,
				paymentFrequency: paymentFrequency,
				averagePaymentAmount: customer.avg_monthly_sales ? customer.avg_monthly_sales * 0.3 : null
			};
		}

		if (customer.openorders) {
			payload.orderHistory = {
				openOrdersCount: Array.isArray(customer.openorders) ? customer.openorders.length : 0,
				recentOrders: Array.isArray(customer.openorders) ? customer.openorders.slice(0, 5).map((o: any) => ({
					orderNumber: o.orderno,
					orderDate: o.orderdate,
					total: o.total || 0,
					status: o.status || 'Open'
				})) : []
			};
		}

		if (customer.customer_since || customer.created_date) {
			const customerSince = customer.customer_since || customer.created_date;
			const lifetimeValue = customer.totalspend || 0;
			payload.relationshipMetrics = {
				customerSince: customerSince,
				lifetimeValue: lifetimeValue,
				yearsAsCustomer: this.calculateYearsAsCustomer(customerSince),
				averageAnnualValue: this.calculateAverageAnnualValue(customerSince, lifetimeValue)
			};
		}

		Object.keys(payload).forEach(key => {
			if (payload[key] === null || payload[key] === undefined || payload[key] === '') {
				delete payload[key];
			} else if (typeof payload[key] === 'object' && !Array.isArray(payload[key])) {
				Object.keys(payload[key]).forEach(subKey => {
					if (payload[key][subKey] === null || payload[key][subKey] === undefined || payload[key][subKey] === '') {
						delete payload[key][subKey];
					}
				});
				if (Object.keys(payload[key]).length === 0) {
					delete payload[key];
				}
			}
		});

		return payload;
	}

	private calculateDaysOverdue(lastPurchase: string, lastPaidDate: string): number {
		if (!lastPurchase) {return 0;}
		const purchaseDate = new Date(lastPurchase);
		const paidDate = lastPaidDate ? new Date(lastPaidDate) : new Date();
		const diffTime = Math.abs(purchaseDate.getTime() - paidDate.getTime());
		return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
	}

	private calculateCreditRiskLevel(overdue: number, creditLimit: number, daysOverdue: number): string {
		if (!overdue || overdue === 0) {return 'Low';}
		const utilization = creditLimit ? (overdue / creditLimit) * 100 : 0;
		if (utilization > 80 || daysOverdue > 90) {return 'High';}
		if (utilization > 50 || daysOverdue > 60) {return 'Medium';}
		return 'Low';
	}

	private calculatePaymentFrequency(lastPurchase: string, lastPaidDate: string): string {
		if (!lastPurchase || !lastPaidDate) {return 'Unknown';}
		const purchaseDate = new Date(lastPurchase);
		const paidDate = new Date(lastPaidDate);
		const diffDays = Math.abs(purchaseDate.getTime() - paidDate.getTime()) / (1000 * 60 * 60 * 24);
		if (diffDays <= 15) {return 'Frequent';}
		if (diffDays <= 30) {return 'Regular';}
		if (diffDays <= 60) {return 'Occasional';}
		return 'Infrequent';
	}

	private calculateYearsAsCustomer(customerSince: string): number {
		if (!customerSince) {return 0;}
		const sinceDate = new Date(customerSince);
		const now = new Date();
		const diffTime = Math.abs(now.getTime() - sinceDate.getTime());
		return Math.floor(diffTime / (1000 * 60 * 60 * 24 * 365));
	}

	private calculateAverageAnnualValue(customerSince: string, lifetimeValue: number): number {
		const years = this.calculateYearsAsCustomer(customerSince);
		if (years === 0) {return lifetimeValue;}
		return lifetimeValue / years;
	}


	onOpportunityUpdated(opportunity: any): void {
		// Refresh customer data or handle opportunity update
		console.log('Opportunity updated:', opportunity);
		// You can add additional logic here if needed
	}

	onActivityUpdated(activity: any): void {
		// Refresh customer data or handle activity update
		console.log('Activity updated:', activity);
		// You can add additional logic here if needed
	}

	ngOnInit(): void {
		this.setPagination([]);
		this.color = this.globalSearchService.getColor();
		this.globalSearchService.mesagesallowed.next(true);
		this.route.queryParamMap
			.pipe(takeUntil(this.destroy$))
			.subscribe(() => {
				if (this.customerdata?.debtorno) {
					this.applyCustomerRouteDeepLinkFromUrl();
				}
			});
		this.route.params.subscribe(params => {
			const customernumber = params['id'];
			this.debtorno = customernumber;
			this.viewingcards = false;
			this.customerService.getDebtor(customernumber).subscribe(async (results: any) => {
				this.editbilling = false;
				this.newcustomertoggle = false;

				const cleanedCustomerData = this.extractCustomerData(results.customer);
				this.customerAIData = cleanedCustomerData;

				if (this.activeIndex === 0) {
					setTimeout(() => {
						this.globalSearchService.aiDataAvailable$.next(cleanedCustomerData);
						this.globalSearchService.aiDataContext$.next('customer_data');
					}, 100);
				} else {
					this.globalSearchService.aiDataAvailable$.next(null);
				}



				this.edittoggle = false;
				this.editing_settings = false;
				this.editing_shipping = false;
				this.editing_notes = false;
				this.editing_contacts = false;
				this.editing_ar = false;
				this.customerdata = results;
				this.globalSearchService.lastCustomer.next(results.customer_id);
				this.activeIndex = 0;
				this.filterNotes();
				this.refusedemail = this.customerdata.customer.refusedemail
				this.applyCustomerRouteDeepLinkFromUrl();
				//this.customerService.getAccountInq(customernumber).subscribe(async (results: any) => {
				//	this.transactions = results;
				//	this.globalSearchService.lastCustomerTrans.next(results);
				//});
			});
		});


	}

	/**
	 * Honors `?tab=` and `?branch=` when opening the customer from AR trial balance (or bookmarks).
	 * `tab=transactions` — main tab strip, Transactions (inquiry / adjustments).
	 * `tab=ar` — Customer Info with AR card in edit mode (when permitted).
	 */
	private applyCustomerRouteDeepLinkFromUrl(): void {
		const q = this.route.snapshot.queryParamMap;
		const tab = (q.get('tab') || '').trim().toLowerCase();
		const branch = (q.get('branch') || '').trim();
		if (!this.customerdata?.debtorno) {
			return;
		}
		const applyTabIntent = () => {
			if (tab === 'transactions') {
				this.activeIndex = 1;
				this.editing_ar = false;
			} else if (tab === 'ar') {
				this.activeIndex = 0;
				if (this.editsallowed?.editar) {
					this.editing_ar = true;
				}
			}
			this.cdr.markForCheck();
		};
		const currentBc = String(this.customerdata.branchcode ?? '').trim();
		if (branch && branch !== currentBc) {
			this.customerService.getDebtorWithBranch(this.customerdata.debtorno, branch).subscribe((r: any) => {
				this.customerdata = r;
				applyTabIntent();
			});
			return;
		}
		applyTabIntent();
	}

	removeCustomer() {
		if (this.customerdata) {

			if (this.user.user.customeradmin == '1') {
				if (!confirm('Really delete customer ' + this.customerdata.debtorno + '? This cannot be undone.')) {
					return;
				}
				this.customerService.removeDebtor(this.customerdata).subscribe(async (results: any) => {
					if (results.success) {
						this.router.navigate(['./customers']);
					} else {
						alert('Can Not Remove Customer: \n' + results.reasons);
					}
				});
			}
		}
	}

	getTaxAuth(taxgroupid: any) {
		if (this.taxauths) {
			const auth = this.taxauths.filter(r => {
				return r.taxgroupid == taxgroupid
			})[0];
			if (auth && auth.taxgroupdescription) {

				return auth.taxgroupdescription + ' ' + auth.rate;
			} else {
				return 'N/A';
			}

		} else {
			return 'N/A';
		}
	}

	loadCustomerBranch(event: any) {

		if (event === true) {
			this.customerService.getDebtor(this.debtorno).subscribe(async (results: any) => {
				this.customerdata = results;
				//this.globalSearchService.aiDataAvailable$.next(results);
				//this.globalSearchService.aiDataContext$.next('customer');
				this.globalSearchService.lastCustomer.next(results.customer_id);
			});
		} else {
			this.customerService.getDebtorWithBranch(event.debtorno, event.branchcode).subscribe(async (results: any) => {
				this.customerdata = results;
				//this.globalSearchService.aiDataAvailable$.next(results);
				//this.globalSearchService.aiDataContext$.next('customer');
				this.globalSearchService.lastCustomer.next(results.customer_id);
			});
		}
	}

	loadCustomer(event: any) {

		this.customerService.getDebtor(this.debtorno).subscribe(async (results: any) => {
			this.customerdata = results;
			this.globalSearchService.lastCustomer.next(results.customer_id);
			this.viewingcards = false;
			this.invoicing = false;
			this.isactive = this.customerdata.customer.isactive
			this.refusedemail = this.customerdata.customer.refusedemail
			this.filterNotes();

			//this.customerService.getAccountInq(this.debtorno).subscribe(async (results: any) => {
			//	this.transactions = results;
			//	this.globalSearchService.lastCustomerTrans.next(results);
			//});
		});
	}

	selectCustomer(row: any) {
		this.router.navigate(['./customers/view/' + row.debtorno]);
	}

	onOrderUploaded(_event?: unknown) {
		this.updateActiveIndex(2);
		this.loadCustomer(true);
	}

	checkTab(event: any) {
		switch (event.index) {
		case 1:
			this.reloadData = true;
			break;
		default:
			break;
		}
	}

	toggleTransactions(intype: any) {
		this.ctl = false;
		if (!this.ctl) {
			this.globalSearchService.mesagesallowed.next(true);
		}
		this.viewingtrans = intype;
		switch (this.flip) {
		case 'inactive':
			this.flip = 'active';
			this.flip_button_txt = 'Customer Info'

			break;
		default:
			//flip back to customer info (transactions is flipped back and fourth)
			if (this.viewingtrans == 'transactions') {
				this.flip = 'inactive';
				this.flip_button_txt = 'Transactions'
			}
			break;
		}
	}

	getPriceListName(code: any): string {
		const pricelist = this.pricelists.find(pricelist => pricelist.typeabbrev === code);
		return pricelist?.sales_type || 'N/A';
	}

	changeBranch(branchcode: any) {
		this.customerService.getDebtorWithBranch(this.customerdata.debtorno, branchcode).subscribe(async (results: any) => {
			this.customerdata = results;
		});
	}

	newShipTo() {
		this.text_add_button = (this.text_add_button == 'Add New Ship-To') ? 'Cancel Add New Ship To' : 'Add New Ship-To';
		this.newcustomertoggle = (this.newcustomertoggle) ? false : true;
		this.edittoggle = false;
	}

	updateRefused(event: any) {

		this.refusedemail = event.target.checked;

		const data = {
			debtorno: this.customerdata.debtorno,
			branchcode: this.customerdata.branchcode,
			refusedemail: event.target.checked
		}

		this.customerService.updateDebtorRefused(data).subscribe((results) => {
			this.customerdata = results;
		});
	}

	updateActive(event: any) {
		//event.preventDefault();
		if (this.customerdata.customer.isactive) {
			const confirmed = confirm('Mark Customer as Inactive?');
			if (confirmed) {
				const data = {
					debtorno: this.customerdata.debtorno,
					branchcode: this.customerdata.branchcode,
					isactive: false
				}
				this.customerService.updateDebtorActive(data).subscribe((results) => {
					this.customerdata = results;
				});
			} else {
				return false;
			}
		} else {
			this.modalService.open(this.inactiveModalRef, { ariaLabelledBy: 'modal-basic-title', size: 'xl' }).result.then((result) => {
				this.closeResult = `Closed with: ${result}`;
				this.editing_shipping = false;
			}, (reason) => {
				this.updateShipToEdit('any');
				this.editing_shipping = false;
				this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
			});

			this.reactivateCustomer()
		}
	}

	reactivateCustomer() {
		const data = {
			debtorno: this.customerdata.debtorno,
			branchcode: this.customerdata.branchcode,
			isactive: true
		}
		this.customerService.updateDebtorActive(data).subscribe((results) => {
			this.customerdata = results;
		});
	}

	isActiveText() {
		if (this.customerdata) {
			return (this.customerdata.customer.isactive) ? 'ACTIVE' : 'INACTIVE';
		}
		return '';
	}
	customerAIData: any = null;

	updateActiveIndex(event: any) {
		if (event === 0) {
			if (this.customerAIData) {
				setTimeout(() => {
					this.globalSearchService.aiDataAvailable$.next(this.customerAIData);
					this.globalSearchService.aiDataContext$.next('customer_data');
				}, 100);
			}
		} else {
			this.globalSearchService.aiDataAvailable$.next(null);
		}

		if(this.activeIndex == 5 && event !== 5){
			this.lookingForRma = false;
		}
		this.globalSearchService.helpManualAvailable$.next(null);
		this.activeIndex = event;
		switch (this.activeIndex) {
		//force update customer on reselect index
		case 2:
			this.isItemLookup = true;
			break;
		case 0:
			this.customerService.getDebtor(this.debtorno).subscribe(async (results: any) => {
				this.customerdata = results;
			});
			this.isItemLookup = false;
			break;
		default:
			this.isItemLookup = false;
			break;
		}
	}


	addCreditItems(items: any) {

		// cart_credit.orderno is "the credit order this line belongs to". Putting the
		// source SALES order in there makes shared-credit-entry read the cart as a
		// staged RMA and reload it through credits/loadorder — that lookup finds no
		// creditorder, returns an empty cart, and the screen ends up with a negative
		// total and no lines. The source document belongs in original_orderno /
		// original_orderlineno, the same keys the credit-from-invoice path writes.
		const payload = items.map(item => ({
			original_orderno: item.original_orderno,
			original_orderlineno: item.original_orderline,
			stockid: item.stockid,
			description: item.description,
			discount: parseFloat(item.discountpercent) * 100,
			quantity: item.qty,
			price: parseFloat(item.price),
			debtorno: item.debtorno,
			branchcode: item.branchcode,
		}));

		// Navigate only once the lines are actually in the cart — the credit screen
		// reads the cart on init, so leaving early raced the insert.
		this.creditService.addMultipleToOrder(payload, this.customerdata.debtorno, this.customerdata.branchcode).subscribe((results: any) => {

			if (results.success) {

				items.forEach((item, index) => {
					//reset qtys and show notification
					if (parseFloat(item.quantity) !== 0) {
						const color = (item.isnegative) ? 'warn' : 'success';
						this.globalSearchService.showNotification(item.description + ' x ' + item.qty + ' Added', color, 'bottom', 'left');
					}
				});

				this.router.navigate(['receivables/credit-note/' + this.customerdata.debtorno + '/' + this.customerdata.branchcode]);

			} else {
				this.globalSearchService.showNotification(results.message, 'danger', 'bottom', 'left');
			}
		});

	}

	updateCreditData(event: any) {
		this.credit_data = event;
		this.customerdata.openrmas = event;
	}


	loadQuote(quote: any) {

		this.orderService.loadQuote(quote.orderno).subscribe((r: any) => {

			this.changeBranch(r.header.branchcode);
			this.activeIndex = 2;
			this.loadedQuote = true;

		})
		/*
		//let service = this.orderService;
		this.orderService.clearOrder(this.customerdata.debtorno, this.customerdata.branchcode).subscribe( (cleared: any) => {
			quote.details.forEach( (item: any)  => {
				let item_add = {
					stockid: item.stkcode,
					quantity: item.quantity,
					price: item.unitprice,
					discount: item.discountpercent,
				}
				service.addToOrder(item_add, this.customerdata.debtorno, this.customerdata.branchcode).subscribe(async (results: any) => {
				});
			});
			//active index item lookup

		});
		*/
	}

	selectTransactions() {
		this.activeIndex = 1;

	}

	invoiceOrder(event: any) {
		this.invoicing = event;
		this.selectItemLookup(event);
	}

	loadPreOrder(event: any) {

		if (event.header) {
			this.customerService.getDebtorWithBranch(event.header.debtorno, event.header.branchcode).subscribe(async (results: any) => {
				this.customerdata = results;
			});
		}
		this.activeIndex = 2;
	}

	selectItemLookup(event: any) {

		if (event.header) {
			this.customerService.getDebtorWithBranch(event.header.debtorno, event.header.branchcode).subscribe(async (results: any) => {
				this.customerdata = results;
			});
		}
		this.activeIndex = 2;
	}

	setInvoice() {
		this.invoicing = true;
	}

	ngAfterViewInit() {

	}

	onUploadError(event: any) {

	}

	onUploadSuccess(event: any) {

	}

	onSelect(event: any) {

		this.files.push(...event.addedFiles);
		for (let i = 0; i < this.files.length; i++) {
			this.readFile(this.files[i]).then(fileContents => {
				//stuff

				const upload = {
					content: fileContents,
					name: event.addedFiles[0].name,
					mime: event.addedFiles[0].type,
				}

				this.customerService.uploadFile(upload, this.customerdata.debtorno).subscribe((results: any) => {
					this.customerdata.customer_files = results.customer_files;
					this.files = [];
				});

			});
		}
	}

	removeFile(link: any) {
		const data = { link: link, debtorno: this.customerdata.debtorno }
		this.customerService.removeFile(data).subscribe((result: any) => {
			this.customerdata.customer_files = result.customer_files;
		})

	}
	onRemove(event: any) {
		this.files.splice(this.files.indexOf(event), 1);
	}


	salemanName(input: any) {
		const name = this.customerdata.salespeople.filter((p) => {
			return p.code == input
		})[0];
		if (name) {
			return name.name
		}
		return 'N/A';
	}

	paymenttoggle() {
		this.payment = (this.payment) ? false : true;
		if (!this.payment) {
			//	this.globalSearchService.mesagesallowed.next(true);
		}
	}
	ctlonoff() {
		this.ctl = (this.ctl) ? false : true;
		if (!this.ctl) {
			//	this.globalSearchService.mesagesallowed.next(true);
		}
	}

	toggleAttach() {
		this.attach_file = (this.attach_file) ? false : true;
	}

	back(): void {
		this.location.back()
	}

	//prevents cart collapse on activity
	stopProp(event: any): void {
		event.stopPropagation();
	}


	updateSettingEdit(input: any) {
		this.editing_settings = (this.editing_settings) ? false : true;
	}

	updateArEdit(input: any) {
		if (this.editsallowed.editar) {
			this.editing_ar = (this.editing_ar) ? false : true;
		}
	}

	updateContactEdit(input: any) {
		this.editing_contacts = (this.editing_contacts) ? false : true;
	}
	updateNoteEdit(input: any) {
		this.editing_notes = (this.editing_notes) ? false : true;
	}

	// Notes filtering methods
	filterNotes() {
		if (!this.customerdata?.notes) {
			this.filteredNotes = [];
			return;
		}
		
		if (this.selectedNoteFilter === 'ALL') {
			this.filteredNotes = this.customerdata.notes;
		} else {
			this.filteredNotes = this.customerdata.notes.filter((note: any) => 
				note.note_code === this.selectedNoteFilter
			);
		}
	}

	onNoteFilterChange() {
		this.filterNotes();
	}

	updateShipToEdit(input: any) {
		this.editing_shipping = (this.editing_shipping) ? false : true;
		//this.modalService.close('#shiptodetails')
	}
	//switch isnt working moviing to indivdual function
	updateEditing(input: any) {
		//this.modalService.dismiss('');

		switch (input) {
		case 'shipping':
			this.editing_shipping = (this.editing_shipping) ? false : true;
			break;
		case 'notes':
			this.editing_notes = (this.editing_notes) ? false : true;
			break;
		case 'settings':
			this.editing_settings = (this.editing_settings) ? false : true;
			break;
		default:
			this.editbilling = (this.editbilling) ? false : true;
			break;
		}
	}

	edit(content: any) {
		switch (content) {
		case 'editing_contacts':
			if (this.editsallowed.editcontact) {
				this.editing_contacts = (this.editing_contacts) ? false : true;
			}
			break;
		case 'notes':
			if (this.editsallowed.editnotes) {
				this.editing_notes = (this.editing_notes) ? false : true;
			}
			break;
		case 'shipping':
			if (this.editsallowed.editshipping) {
				this.editing_shipping = (this.editing_shipping) ? false : true;
			}
			break;
		case 'settings':
			if (this.editsallowed.editprofile) {
				this.editing_settings = (this.editing_settings) ? false : true;
			}
			break;
		default:
			if (this.editsallowed.editbilling) {
				this.editbilling = (this.editbilling) ? false : true;
			}
			break;
		}
	}

	openShippingModal(content: any): void {
		if (this.editsallowed.editshipping) {
			this.openModal(content);
		}
	}

	getYesNo(input: boolean): string {
		return (input) ? 'Y' : 'N';
	}

	updateBranch(input: any): void {
		this.customerService.getDebtor(this.debtorno).subscribe((results: any) => {
			this.customerdata = results;
			this.modalService.dismissAll('close');
			this.updateShipToEdit('close');
			this.newcustomertoggle = false;
		});
	}

	updateCustomer(input: any): void {
		const wasEditingSettings = this.editing_settings;
		this.customerdata = input;
		this.filterNotes();
		// Preserve editing state after customer data update
		if (wasEditingSettings) {
			this.editing_settings = true;
		}
	}

	openChangelogModal(): void {
		this.modalService.open(this.changelogModalRef, { ariaLabelledBy: 'modal-changelog-title', size: 'xl' }).result.then((result)=>{
		}, (reason)=>{
			const ele = document.getElementById('changelog')
			if(ele){
				ele.blur();
			}
		});

		setTimeout(()=>{
			this.changelogdebtor = false
			this.changelogdebtor = this.customerdata.customer.debtorno;
		},250)

	}

	openDocument(doc: any): void {
		this.viewingdoc = doc;
		this.modalService.open(this.documentModalRef, { ariaLabelledBy: 'modal-basic-title', size: 'xl' }).result.then((result) => {
			this.closeResult = `Closed with: ${result}`;
		}, (reason) => {
			this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
		});
	}

	openModal(content: any): void {
		this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'xl' }).result.then((result) => {
			this.closeResult = `Closed with: ${result}`;
			this.editing_shipping = false;
		}, (reason) => {
			this.updateShipToEdit('any');
			this.editing_shipping = false;
			this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
		});
	}

	getDismissReason(reason: any): string {
		if (reason === ModalDismissReasons.ESC) {
			return 'by pressing ESC';
		} else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
			return 'by clicking on a backdrop';
		} else {
			return `with: ${reason}`;
		}
	}

	loadPayments(): void {
		//this.router.navigate(['/receivables/payment-entry/311/00']);
	}

	private async readFile(file: File): Promise<string | ArrayBuffer> {
		return new Promise<string | ArrayBuffer>((resolve, reject) => {
			const reader = new FileReader();

			reader.onload = e => {
				return resolve((e.target as FileReader).result);
			};

			reader.onerror = e => {
				console.error(`FileReader failed on file ${file.name}.`);
				return reject(null);
			};

			if (!file) {
				return reject(null);
			}
			reader.readAsDataURL(file);
		});
	}

	getBrandSales(debtorno: any, brand: any): void {
		const today = new Date();
		//var priorDate = new Date(new Date().setDate(today.getDate() - this.daysmax));

		const data = {
			debtorno: debtorno,
			brands: [brand],
			from: 'all',
			//to: today,
		};

		this.customerService.searchCustomerHistory(data).subscribe(async (results: any) => {
			this.sending = false;
			this.brand_details = results;
			this.setPagination(results.items);
			this.modalService.open(this.monthDetailsRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {}, (reason) => {
				this.setPagination([]);
			});
		});
	}

	getItemTotals(): number {
		let total = 0;
		if (this.brand_details) {
			total = this.brand_details.items.reduce(function(accumulator, c) {
				return accumulator + parseFloat(c.qty);
			}, 0);
		}
		return total;
	}

	getDollarTotals(): number {
		let total = 0;
		if (this.brand_details) {
			total = this.brand_details.items.reduce(function(accumulator, c) {
				return accumulator + parseFloat(c.discountedlinetotal);
			}, 0);
		}
		return total;
	}

	isVideo(file: any): boolean {
		if (!file || !file.link || typeof file.link !== 'string') {
			return false; // Ensure file.link exists and is a string
		}

		// Define supported video extensions
		const videoExtensions = [
			'mp4', 'mov', 'avi', 'wmv', 'flv', 'mkv', 'webm', 'ogg', 'm4v'
		];

		// Extract filename without query parameters
		const filename = file.link.split('?')[0];

		// Create a case-insensitive regex pattern for matching video extensions
		const videoRegex = new RegExp(`\\.(${videoExtensions.join('|')})$`, 'i');

		return videoRegex.test(filename);
	}


	isImage(file: any): boolean {

		if (!file || !file.link || typeof file.link !== 'string') {
			return false;
		}

		const imageExtensions = [
			'jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'tiff', 'tif',
			'heic', 'heif', 'ico', 'svg', 'raw', 'cr2', 'nef',
			'orf', 'sr2', 'psd', 'ai', 'eps', 'avif'
		];

		// Extract filename without query parameters
		const filename = file.link.split('?')[0]; // Remove URL params
		// Create a case-insensitive regex pattern for matching image extensions
		const imageRegex = new RegExp(`\\.(${imageExtensions.join('|')})$`, 'i');

		return imageRegex.test(filename);
	}

	
	brands: any = [];
	included: any = 0;
	excluded: any = 0;
	generating: any = false;
	generatePricebook(){
		this.brands = [];
		this.inventoryService.getBrands().subscribe((res: any)=>{
			this.brands = res.map((b)=>{
				b.included = true;
				return b;
			})
			this.brandCount();
			this.modalService.open(this.pricebookModalRef, { ariaLabelledBy: 'modal-basic-title', size: 'xl' }).result.then((result) => { }, (reason) => { });
		})
		
	}

	setAllBrands(type){
		this.brands.forEach((brand)=>{
			brand.included = type;
		})
		this.brandCount();
	}

	toggleBrand(brand){
		brand.included = !brand.included;
		this.brandCount();
	}

	brandCount(){
		this.included = 0;
		this.excluded = 0;
		this.brands.forEach((b)=>{
			b.included ? this.included++ : this.excluded++;
		})
	}

	downloadPricebook(){
		this.generating = true;
		const included = this.brands.map((b)=>{
			if(b.included){return b.manufacturer_id}
		});

		const date = new Date();
		const y = date.getFullYear();
		const m = date.getMonth();
		const d = date.getDate();

		const data = {
			'brand': included,
			'pricelvl': this.customerdata.customer.salestype
		}

		this.customerService.generatepricebook(data).subscribe((blob: Blob)=>{
			this.generating = false;
			FileSaver.saveAs(blob, `pricebook-${y}${m}${d}.csv`);
		})
	}

	ngOnChanges(changes: any): void {
		this.loadCustomer(null);
	}

	setPagination(tableData: any): void {
		this.dataSource = new MatTableDataSource<any>(tableData);
		this.cdr.detectChanges();
		this.dataSource.paginator = this.paginator;
		this.dataObs = this.dataSource.connect();
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	showRma(input: any): void {
		this.activeIndex = 5;
		this.lookingForRma = input;
	}
}